// extracted by mini-css-extract-plugin
export default {"EmptyState":"InvoiceList_EmptyState__6WCq-"};